import {BasicLayout, UserLayout, RouteView} from "@/layouts";
import {shallowRef} from "vue";

export const asyncRoutes = [
    {
        path: '/',
        name: 'index',
        meta: {title: 'Home'},
        redirect: "/vip/list",
        component: shallowRef(BasicLayout),
        children: [
            {
                path: '/vip',
                name: 'vip-index',
                component: shallowRef(RouteView),
                meta: {title: '会员管理', icon: 'members', permission: ["member"]},
                children: [
                    {
                        path: '/vip/list',
                        name: 'vip-list',
                        meta: {title: '会员列表', permission: ["member"], keepAlive: true},
                        component: () => import('@/pages/vip/vip-list'),
                    },
                    {
                        path: '/vip/create',
                        name: 'vip-create',
                        meta: {title: '新增会员', permission: ["member-edit"]},
                        component: () => import('@/pages/vip/modify-member'),
                    },
                    {
                        path: '/vip/edit',
                        name: 'vip-edit',
                        meta: {title: '编辑会员', hidden: true, permission: ["member-edit"]},
                        component: () => import('@/pages/vip/modify-member'),
                    },
                    {
                        path: '/vip/info',
                        name: 'vip-info',
                        meta: {title: '会员信息', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/vip/member-info'),
                    },
                    {
                        path: '/bodycheck/list',
                        name: 'body-check-list',
                        meta: {title: '影像档案列表', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/body-check/check-list'),
                    },
                    {
                        path: '/bodycheck/create',
                        name: 'body-check-create',
                        meta: {title: '新建影像档案', hidden: true, permission: ["member-edit"]},
                        component: () => import('@/pages/body-check/modify-check-record'),
                    },
                    {
                        path: '/bodycheck/info',
                        name: 'body-check-info',
                        meta: {title: '影像档案', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/body-check/check-info'),
                    },
                    {
                        path: '/bodycheck/record/modify',
                        name: 'body-check-modify',
                        meta: {title: '编辑影像档案', hidden: true, permission: ["member-edit"]},
                        component: () => import('@/pages/body-check/modify-check-record'),
                    },
                    {
                        path: '/checkrecord/list',
                        name: 'check-record-list',
                        meta: {title: '检查记录列表', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/check-record/record-list'),
                    },
                    {
                        path: '/checkrecord/view',
                        name: 'check-record-view',
                        meta: {title: '检查记录', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/check-record/record-view'),
                    },
                    {
                        path: '/checkrecord/modify',
                        name: 'check-record-modify',
                        meta: {title: '编辑检查记录', hidden: true, permission: ["member-edit"]},
                        component: () => import('@/pages/check-record/record-modify'),
                    },
                    {
                        path: '/health/list',
                        name: 'health-list',
                        meta: {title: '健康管理列表', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/health/health-list'),
                    },
                    {
                        path: '/health/expert/access',
                        name: 'health-expert-access',
                        meta: {title: '专家随访', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/health/expert/expert-access'),
                    },
                    {
                        path: '/health/expert/access/edit',
                        name: 'health-expert-access-edit',
                        meta: {title: '编辑-专家随访', hidden: true, permission: ["member-edit"]},
                        component: () => import('@/pages/health/expert/expert-access-edit'),
                    },
                    {
                        path: '/health/doctor/access',
                        name: 'health-doctor-access',
                        meta: {title: '私人医生随访', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/health/doctor/doctor-access'),
                    },
                    {
                        path: '/health/doctor/access/edit',
                        name: 'health-doctor-access-edit',
                        meta: {title: '编辑-私人医生随访', hidden: true, permission: ["member-edit"]},
                        component: () => import('@/pages/health/doctor/doctor-access-edit'),
                    },
                    {
                        path: '/health/assistant/access',
                        name: 'health-assistant-access',
                        meta: {title: '健康助理随访', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/health/assistant/assistant-access'),
                    },
                    {
                        path: '/health/assistant/access/edit',
                        name: 'health-assistant-access-edit',
                        meta: {title: '编辑-健康助理随访', hidden: true, permission: ["member-edit"]},
                        component: () => import('@/pages/health/assistant/assistant-access-edit'),
                    },
                    {
                        path: '/health/month/plan',
                        name: 'health-month-plan',
                        meta: {title: '月度管理计划', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/health/month/month-plan'),
                    },
                    {
                        path: '/health/month/plan/edit',
                        name: 'health-month-plan-edit',
                        meta: {title: '编辑-月度管理计划', hidden: true, permission: ["member-edit"]},
                        component: () => import('@/pages/health/month/month-plan-edit'),
                    },
                    {
                        path: '/health/month/summary',
                        name: 'health-month-summary',
                        meta: {title: '月度管理小结', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/health/month/month-summary'),
                    },
                    {
                        path: '/health/month/summary/edit',
                        name: 'health-month-summary-edit',
                        meta: {title: '编辑-月度管理小结', hidden: true, permission: ["member-edit"]},
                        component: () => import('@/pages/health/month/month-summary-edit'),
                    },
                    {
                        path: '/health/month/report',
                        name: 'health-month-report',
                        meta: {title: '健康评估报告', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/health/month/month-report'),
                    },
                    {
                        path: '/health/month/report/edit',
                        name: 'health-month-report-edit',
                        meta: {title: '编辑-健康评估报告', hidden: true, permission: ["member-edit"]},
                        component: () => import('@/pages/health/month/month-report-edit'),
                    },
                    {
                        path: '/health/year/plan',
                        name: 'health-year-plan',
                        meta: {title: '年度检查计划', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/health/year/year-plan'),
                    },
                    {
                        path: '/health/year/plan/edit',
                        name: 'health-year-plan-edit',
                        meta: {title: '编辑-年度计划', hidden: true, permission: ["member-edit"]},
                        component: () => import('@/pages/health/year/year-plan-edit'),
                    },
                    {
                        path: '/health/access/form',
                        name: 'health-access-form',
                        meta: {title: '专家随访准备表', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/health/access/access-form'),
                    },
                    {
                        path: '/health/access/form/edit',
                        name: 'health-access-form-edit',
                        meta: {title: '编辑专家随访准备表', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/health/access/access-form-modify'),
                    },
                    {
                        path: '/health/month/preview/mobile',
                        name: 'health-month-preview-mobile',
                        meta: {title: '月计划预览-移动版', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/health/month/preview/mobile-preview'),
                    },
                    {
                        path: '/health/month/preview/pc',
                        name: 'health-month-preview-pc',
                        meta: {title: '月计划预览-PC版', hidden: true, permission: ["member"]},
                        component: () => import('@/pages/health/month/preview/pc-preview'),
                    },
                ],
            },
            {
                path: '/finance',
                name: 'finance-index',
                component: shallowRef(RouteView),
                meta: {title: '会籍管理', icon: 'finance', permission: ["finance"]},
                children: [
                    {
                        path: '/finance/fee/member/list',
                        name: 'fee-member-list',
                        meta: {title: '会籍列表', permission: ["finance"]},
                        component: () => import('@/pages/finance/fee-member-list'),
                    },
                    {
                        path: '/finance/fee/member/modify',
                        name: 'fee-member-modify',
                        meta: {title: '会籍编辑', hidden: true, permission: ["finance"]},
                        component: () => import('@/pages/finance/modify-fee-member'),
                    },
                ],
            },
            {
                path: '/doctor',
                name: 'doctor-index',
                component: shallowRef(RouteView),
                meta: {title: '医生管理', icon: 'doctor', permission: ["doctor"]},
                children: [
                    {
                        path: '/doctor/list',
                        name: 'doctor-list',
                        meta: {title: '医生列表', permission: ["doctor"]},
                        component: () => import('@/pages/doctor/doctor-list'),
                    },
                    {
                        path: '/doctor/info',
                        name: 'doctor-info',
                        meta: {title: '医生信息', hidden: true, permission: ["doctor"]},
                        component: () => import('@/pages/doctor/doctor-info'),
                    },
                    {
                        path: '/doctor/modify',
                        name: 'doctor-modify',
                        meta: {title: '医生编辑', hidden: true, permission: ["doctor-edit"]},
                        component: () => import('@/pages/doctor/doctor-modify'),
                    },
                ],
            },
            {
                path: '/hr',
                name: 'hr-index',
                component: shallowRef(RouteView),
                meta: {title: '医护管理', icon: 'hr', permission: ["hr"]},
                children: [
                    {
                        path: '/hr/staff/list',
                        name: 'hr-staff-list',
                        meta: {title: '医护列表', permission: ["hr"]},
                        component: () => import('@/pages/statistic/statistic-doctor-list'),
                    },
                    {
                        path: '/hr/staff/info',
                        name: 'hr-staff-info',
                        meta: {title: '医护工作记录', hidden: true, permission: ["hr"]},
                        component: () => import('@/pages/statistic/statistic-doctor-info'),
                    },
                ],
            },
            {
                path: '/suggest',
                name: 'suggest-index',
                component: shallowRef(RouteView),
                meta: {title: '投诉管理', icon: 'suggest', permission: ["suggest"]},
                children: [
                    {
                        path: '/suggest/list',
                        name: 'suggest-list',
                        meta: {title: '投诉列表', permission: ["suggest"]},
                        component: () => import('@/pages/suggest/suggest-list'),
                    }
                ],
            },
            {
                path: '/questionnaire',
                name: 'questionnaire-index',
                component: shallowRef(RouteView),
                meta: {title: '奕宁互动', icon: 'questionnaire', permission: ["questionnaire"]},
                children: [
                    {
                        path: '/questionnaire/list',
                        name: 'questionnaire-list',
                        meta: {title: '互动列表', permission: ["questionnaire"]},
                        component: () => import('@/pages/questionnaire/question-list'),
                    },
                    {
                        path: '/questionnaire/modify',
                        name: 'questionnaire-modify',
                        meta: {title: '问卷编辑', hidden: true, permission: ["questionnaire"]},
                        component: () => import('@/pages/questionnaire/questionnaire-modify'),
                    },
                    {
                        path: '/questionnaire/answer',
                        name: 'qanswer-list',
                        meta: {title: '会员回访问卷', hidden: true, permission: ["questionnaire"]},
                        component: () => import('@/pages/questionnaire/qanswer-list'),
                    }
                ],
            },
            {
                path: '/system',
                name: 'system-index',
                component: shallowRef(RouteView),
                meta: {title: '系统管理', icon: 'system', permission: ["system"]},
                children: [
                    {
                        path: '/system/account/list',
                        name: 'account-list',
                        meta: {title: '账号列表', permission: ["account"]},
                        component: () => import('@/pages/system/account-list'),
                    },
                    {
                        path: '/account/create',
                        name: 'account-create',
                        meta: {title: '创建账号', permission: ["account"]},
                        component: () => import('@/pages/system/account-modify'),
                    },
                    {
                        path: '/account/edit',
                        name: 'account-edit',
                        meta: {title: '编辑账号', hidden: true, permission: ["account"]},
                        component: () => import('@/pages/system/account-modify'),
                    },
                    {
                        path: '/doctor/type/list',
                        name: 'doctor-type-list',
                        meta: {title: '角色管理', permission: ["doctor-type"]},
                        component: () => import('@/pages/system/doctor-type-list'),
                    },
                    {
                        path: '/system/member/trash/list',
                        name: 'member-trash-list',
                        meta: {title: '会员回收站', permission: ["trash"]},
                        component: () => import('@/pages/system/member-trash-list'),
                    },
                ],
            },
            {
                path: '/company',
                name: 'company-index',
                component: shallowRef(RouteView),
                meta: {title: '奕宁信息', icon: 'company', permission: ["company"]},
                children: [
                    {
                        path: '/company/edit',
                        name: 'company-edit',
                        meta: {title: '关于奕宁', permission: ["company"]},
                        component: () => import('@/pages/company/company-edit'),
                    }
                ],
            },
        ]
    },

];

export const constantRoutes = [{
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    children: [
        {
            path: 'login',
            name: "login",
            component: () => import('@/pages/user/login'),
        }
    ]
}];